import React from 'react';
import { GovBanner } from '@gov-design-system-ce/react';

export interface BannerProps {
	headline?: string;
	children?: string | React.ReactNode;
	image?: string;
	className?: string;
}

export const Banner = ({
	headline,
	children,
	image,
	className,
}: BannerProps) => (
	<GovBanner
		size="s"
		background="simple"
		foreground="image"
		className={className}>
		<h1
			slot="headline"
			id="main-banner">
			{headline}
		</h1>
		{children}
		<img
			src={`assets\\images\\${image}`}
			slot="image"
			alt="Banner"
		/>
	</GovBanner>
);
